<template>
    <div class="image-box">
        <div class="commodity-image-area">
            <img
                class="commodity-image"
                :src="commodityImageUrl"/>
            <div
                v-bind:style="{ 'opacity': tagOpacity }"
                v-on:mouseenter="mouseEnter"
                v-on:mouseleave="mouseLeave"
                class="commodity-tag-area">
                <div
                    v-for="(tag, tagIndex) in commodityTags"
                    :key="tagIndex">
                    <div
                        v-on:click="selectTag"
                        v-bind:class="{ 'commodity-tag-active': tag.active }"
                        :data-commodityindex="commodityIndex"
                        :data-tagindex="tagIndex"
                        class="commodity-tag">
                        {{ tag.name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="description">
            {{ commodityDescription }}
        </div>
    </div>
</template>

<script>
 export default {
     name: "Commodity",
     data() {
         return {
             isHover: false,
             commodityTags: [
                 {
                     name: "背景不干净",
                     active: false
                 },
                 {
                     name: "商品不清晰",
                     active: false
                 },
                 {
                     name: "光线太暗",
                     active: false
                 },
                 {
                     name: "光线太亮",
                     active: false
                 },
                 {
                     name: "商品太大",
                     active: false
                 },
                 {
                     name: "商品太小",
                     active: false
                 },
                 {
                     name: "角度不对",
                     active: false
                 },
                 {
                     name: "不是正方形",
                     active: false
                 },
                 {
                     name: "不是2倍拍摄",
                     active: false
                 },
                 {
                     name: "商品未摆正",
                     active: false
                 }
             ]
         }
     },
     computed: {
         tagOpacity() {
             if (this.isHover) {
                 return "1"
             } else {
                 var activeTags = this.commodityTags.filter((e) => {
                     return e.active
                 })

                 if (activeTags.length > 0) {
                     return "1"
                 } else {
                     return "0"
                 }
             }
         }
     },
     props: {
         commodityDescription: {
             type: String,
             required: true
         },
         commodityImageUrl: {
             type: String,
             required: true
         },
         commodityIndex: {
             type: Number,
             required: true
         }
     },
     methods: {
         selectTag(e) {
             var tags = this.commodityTags
             tags[e.target.dataset.tagindex].active = !tags[e.target.dataset.tagindex].active
             this.commodityTags = tags
         },

         mouseEnter() {
             this.isHover = true
         },

         mouseLeave() {
             this.isHover = false
         },

         reset() {
             var tags = this.commodityTags
             for (var i = 0; i < tags.length; i++) {
                 tags[i].active = false
             }

             this.commodityTags = tags
         }
     }
 }
</script>

<style scoped>
 .image-box {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     padding-left: 10px;
     padding-right: 10px;
 }

 .description {
     border-radius: 5px;
     background-color: #EFEFEF;
     font-size: 13px;
     color: #333;
     height: 23px;
     width: 100px;
     padding-top: 3px;
     margin-top: 10px;
     margin-bottom: 20px;
 }

 .commodity-tag-area {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     height: 100%;
     width: 100%;
     transition: .5s ease;
     background-color: rgba(0, 0, 0, 0.5);
     border-radius: 5px;

     display: grid;
     grid-template-columns: 105px 105px;
     justify-content: center;
     padding-left: 5px;
 }

 .commodity-image-area {
     position: relative;
 }

 .commodity-tag {
     background-color: rgba(200, 200, 200, 0.9);
     color: #000;
     border-radius: 20px;
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 3px;
     padding-bottom: 3px;
     margin-top: 5px;
     margin-bottom: 5px;
     width: 100px;
     height: 28px;
     user-select: none;
 }

 .commodity-tag-active {
     background-color: #D80E3B;
     color: #FFF;
 }

 .commodity-image {
     width: 220px;
     border-radius: 10px;
     display: block;
 }
</style>
